import * as tslib_1 from "tslib";
import { XMLNode } from "./XMLNode";
import { XMLNodeType } from "./XMLNodeType";
var XML = (function (_super) {
    tslib_1.__extends(XML, _super);
    function XML(text) {
        return _super.call(this, XMLNodeType.XML_DECLARATION, "null") || this;
    }
    XML.prototype.addRequestHeader = function (header, headerValue) {
        console.log("addRequestHeader not implemented yet in flash/XML");
    };
    XML.prototype.createElement = function (name) {
        console.log("createElement not implemented yet in flash/XML");
        return null;
    };
    XML.prototype.createTextNode = function (value) {
        console.log("createTextNode not implemented yet in flash/XML");
        return null;
    };
    XML.prototype.getBytesLoaded = function () {
        console.log("getBytesLoaded not implemented yet in flash/XML");
        return 0;
    };
    XML.prototype.getBytesTotal = function () {
        console.log("getBytesTotal not implemented yet in flash/XML");
        return 0;
    };
    // Central API
    XML.prototype.getRequestHeaders = function () {
        console.log("getRequestHeaders not implemented yet in flash/XML");
        return null;
    };
    // Central API
    XML.prototype.getRequestHeader = function (key) {
        console.log("getRequestHeader not implemented yet in flash/XML");
        return null;
    };
    // Central API
    XML.prototype.getResponseHeaders = function () {
        console.log("getResponseHeaders not implemented yet in flash/XML");
        return null;
    };
    // Central API
    XML.prototype.getResponseHeader = function (key) {
        console.log("getResponseHeader not implemented yet in flash/XML");
        return null;
    };
    // Central API
    XML.prototype.getResponseBody = function () {
        console.log("getResponseBody not implemented yet in flash/XML");
        return null;
    };
    XML.prototype.load = function (url) {
        console.log("load not implemented yet in flash/XML");
        return false;
    };
    XML.prototype.parseXML = function (value) {
        console.log("parseXML not implemented yet in flash/XML");
    };
    XML.prototype.send = function (url, target, method) {
        console.log("send not implemented yet in flash/XML");
        return false;
    };
    XML.prototype.sendAndLoad = function (url, resultXML) {
        console.log("sendAndLoad not implemented yet in flash/XML");
    };
    XML.prototype.onLoad = function (success) {
        console.log("onLoad not implemented yet in flash/XML");
    };
    XML.prototype.onData = function (src) {
        console.log("onData not implemented yet in flash/XML");
    };
    return XML;
}(XMLNode));
export { XML };
